import validate from '../../../services/reduxValidate.js';

export default function(data) {
  const validators = {
    'denial_motive': {
      presence: true,
    }
  };

  return validate(data, validators);
}